import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Select, Upload, Table, Space, Checkbox } from "antd";

import { useAsyncAxios, utilAxiosFormWithAuth, utilAxiosWithAppToken } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";
import { UploadOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/lib/table";
import { DownloadOutlined } from "@ant-design/icons";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";
import * as Common from "../commons/common";
import BBSEditor from "./BBSEditor";
import moment from "moment";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RentRegisterReview({
    editMode,
    boardArticle,
    onRegisterBoardArticle,
}: {
    editMode: string;
    boardArticle?: Types.BoardArticleDto;
    onRegisterBoardArticle?: () => void;
}) {
    const [form] = Form.useForm();
    const alert = useAlert();
    const [selectedBoardArticle, setSelectedBoardArticle] = useState<Types.BoardArticleDto>();
    const [thumbnailFile, setThumbnailFile] = useState<Array<any>>([]);
    const [selectedBoardFiles, setSelectedBoardFiles] = useState<Array<Types.BoardFileDto>>();
    const [selectedMediaChannel, setSelectedMediaChannel] = useState<string>("리뷰게시판");

    const requestAxiosGetBoardArticle = async (boardId: number, boardArticleId: number) => {
        const response = await utilAxiosFormWithAuth().get(Request.BOARD_URL + "/" + boardId + "/" + boardArticleId);

        return response.data;
    };
    const {
        loading: loadingGetBoardArticle,
        error: errorGetBoardArticle,
        data: resultGetBoardArticle,
        execute: requestGetBoardArticle,
    } = useAsyncAxios(requestAxiosGetBoardArticle);

    useEffect(() => {
        if (resultGetBoardArticle === null) return;
        setSelectedBoardArticle(resultGetBoardArticle.boardArticle);
    }, [resultGetBoardArticle]);

    useEffect(() => {
        if (errorGetBoardArticle === null) return;

        console.log("errorGetBoardArticle", errorGetBoardArticle);
        alert.setAlert(errorGetBoardArticle.response.data.code, "리뷰 조회 실패", errorGetBoardArticle.response.data.message);
    }, [errorGetBoardArticle]);

    useEffect(() => {
        if (selectedBoardArticle === null || selectedBoardArticle === undefined) return;
        setSelectedMediaChannel(selectedBoardArticle.extraInfo2);
        form.setFieldsValue(selectedBoardArticle);
        form.setFieldValue("boardId", selectedBoardArticle.board.boardId);
    }, [selectedBoardArticle]);

    const requestAxiosAddBoardArticle = async (data: Types.BoardArticleDto, boardId: number) => {
        //console.log("data : " + data);

        const response = await utilAxiosFormWithAuth().post(Request.BOARD_URL + "/" + boardId, data);

        return response.data;
    };

    const {
        loading: loadingAddBoardArticle,
        error: errorAddBoardArticle,
        data: resultAddBoardArticle,
        execute: requestAddBoardArticle,
    } = useAsyncAxios(requestAxiosAddBoardArticle);

    useEffect(() => {
        if (boardArticle === undefined) return;
        requestGetBoardArticle(boardArticle.board.boardId, boardArticle.boardArticleId);
    }, [boardArticle]);

    useEffect(() => {
        if (resultAddBoardArticle === null) return;

        if (onRegisterBoardArticle) onRegisterBoardArticle();

        alert.setAlert(AlertType.SUCCESS, "리뷰 추가 성공", "리뷰 추가를 완료하였습니다.");
    }, [resultAddBoardArticle]);

    useEffect(() => {
        if (errorAddBoardArticle === null) return;

        console.log("errorBoardArticle", errorAddBoardArticle);
        alert.setAlert(errorAddBoardArticle.response.data.code, "리뷰 추가 실패", errorAddBoardArticle.response.data.message);
    }, [errorAddBoardArticle]);

    const requestAxiosUpdateBoardArticle = async (data: any, boardId: number, boardArticleId: number) => {
        //console.log("data : " + data);

        const response = await utilAxiosFormWithAuth().put(Request.BOARD_URL + "/" + boardId + "/" + boardArticleId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateBoardArticle,
        error: errorUpdateBoardArticle,
        data: resultUpdateBoardArticle,
        execute: requestUpdateBoardArticle,
    } = useAsyncAxios(requestAxiosUpdateBoardArticle);

    useEffect(() => {
        if (resultUpdateBoardArticle === null) return;

        if (onRegisterBoardArticle) onRegisterBoardArticle();

        alert.setAlert(AlertType.SUCCESS, "리뷰 수정 성공", "리뷰 수정을 완료하였습니다.");
    }, [resultUpdateBoardArticle]);

    useEffect(() => {
        if (errorUpdateBoardArticle === null) return;

        console.log("errorUpdateBoardArticle", errorUpdateBoardArticle);
        alert.setAlert(errorUpdateBoardArticle.response.data.code, "리뷰 수정 실패", errorUpdateBoardArticle.response.data.message);
    }, [errorUpdateBoardArticle]);

    const onFinish = async (values: any) => {
        const formData = new FormData();
        delete values["files"];

        const data: Types.BoardArticleDto = {
            ...values,
            files: selectedBoardFiles,
        };

        formData.append("boardArticleDto", new Blob([JSON.stringify(data)], { type: "application/json" }));

        if (thumbnailFile.length > 0) {
            const response = await fetch(URL.createObjectURL(thumbnailFile[0]));
            const blob = await response.blob();
            const data = new File([blob], thumbnailFile[0].name, { type: blob.type });

            formData.append("thumbnailFile", data);
        }

        if (editMode === "add") requestAddBoardArticle(formData, values.boardId);
        else if (editMode === "update")
            requestUpdateBoardArticle(formData, selectedBoardArticle?.board.boardId, selectedBoardArticle?.boardArticleId);
    };

    const handleDownloadBoardFile = async (boardId: number, boardFileId: number, boardFileName: string) => {
        await utilAxiosWithAppToken()
            .get(Request.BOARD_URL + "/" + boardId + "/download/" + boardFileId, { responseType: "blob" })
            .then((response) => {
                const file = new Blob([response.data]);
                const element = document.createElement("a");
                element.href = URL.createObjectURL(file);
                element.download = boardFileName;
                element.click();
            })
            .catch((error) => {
                console.log("downloadBoardFile error", error);
                alert.setAlert("", "파일 다운로드 실패", "파일 다운로드에 실패했습니다.");
            });
    };

    const propsThumbnailFile = {
        onRemove: (file: any) => {
            setThumbnailFile([]);
        },
        beforeUpload: (file: any) => {
            setThumbnailFile([file]);
            return false;
        },
        fileList: thumbnailFile,
    };

    const columns: ColumnsType<Types.BoardFileDto> = [
        {
            align: "center",
            title: "썸네일파일ID",
            dataIndex: "boardFileId",
            key: "boardFileId",
            render: (_, { boardFileId }) => {
                return boardFileId !== undefined ? <p>{boardFileId}</p> : "";
            },
        },
        {
            align: "center",
            title: "썸네일파일명",
            dataIndex: "boardFileName",
            key: "boardFileName",
            render: (_, { boardFileId, boardFileName }) => {
                return boardFileName !== undefined ? (
                    <Space
                        onClick={() => handleDownloadBoardFile(selectedBoardArticle?.board.boardId!, boardFileId, boardFileName)}
                        style={{ cursor: "pointer" }}
                    >
                        <DownloadOutlined />
                        <p>{boardFileName}</p>
                    </Space>
                ) : (
                    ""
                );
            },
        },
    ];

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: Types.BoardFileDto[]) => {
            const list: Array<Types.BoardFileDto> = [];
            for (let test of selectedRows) {
                test = {
                    ...test,
                    deleted: true,
                };
                list.push(test);
            }
            setSelectedBoardFiles(list);
        },
    };

    return (
        <Form
            style={{ paddingTop: 20 }}
            form={form}
            onFinish={onFinish}
            initialValues={{ registeredDate: moment().format(Common.FORMAT_DATE_TIME), extraInfo1: "RUTA40XBAYRUN(4인승)" }}
        >
            <Row>
                <Col span={8}>
                    <Form.Item className="searchForm" {...formItemLayout} name="boardArticleId" label="ID">
                        <Input readOnly />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item className="searchForm" {...formItemLayout} name="hits" label="조회수">
                        <Input readOnly />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item
                        className="searchForm"
                        {...formItemLayout}
                        name="registeredDate"
                        label="등록일"
                        rules={[
                            {
                                required: true,
                                message: "등록일을 입력해 주세요.",
                            },
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item className="searchForm" {...formItemLayout} name="extraInfo1" label="차량">
                        <Select options={[{ value: "RUTA40XBAYRUN(4인승)", label: "RUTA40XBAYRUN(4인승)" }]} />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item className="searchForm" {...formItemLayout} name="extraInfo3" label="글쓴이">
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={8} style={{ display: "flex", gap: 0 }}>
                    <Form.Item
                        className="searchForm"
                        {...formItemLayout}
                        name="boardId"
                        label="카테고리"
                        rules={[
                            {
                                required: true,
                                message: "카테고리를 선택하세요.",
                            },
                        ]}
                        style={{ flexGrow: 1 }}
                    >
                        <Select
                            options={[
                                { value: 1, label: "베스트" },
                                { value: 2, label: "리뷰" },
                            ]}
                        />
                    </Form.Item>
                    <Form.Item className="searchForm" {...formItemLayout} name="fixed" valuePropName="checked" style={{ flexGrow: 1 }}>
                        <Checkbox>이달베</Checkbox>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        className="searchForm"
                        {...formItemLayout}
                        name="title"
                        label="제목"
                        rules={[
                            {
                                required: true,
                                message: "제목을 입력해 주세요.",
                            },
                        ]}
                    >
                        <Input placeholder={String.title} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item className="searchForm" {...formItemLayout} name="extraInfo2" label="미디어 채널">
                        <Select
                            defaultValue={"리뷰게시판"}
                            onChange={(value) => setSelectedMediaChannel(value)}
                            options={[
                                { value: "리뷰게시판", label: "리뷰게시판" },
                                { value: "유튜브", label: "유튜브" },
                                { value: "인스타그램", label: "인스타그램" },
                                { value: "네이버", label: "네이버" },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item className="searchForm" {...formItemLayout} name="contents" label="내용">
                        <BBSEditor disabled={selectedMediaChannel !== "리뷰게시판"} hasAttachFiles={false} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item className="searchForm" name="url1" label="외부링크 URL">
                        <Input placeholder={"외부링크URL"} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item className="searchForm" name="url2" label="썸네일 URL">
                        <Input placeholder={"썸네일URL"} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item className="searchForm" {...formItemLayout} name="thumbnailFile" label="썸네일 파일">
                        <Upload {...propsThumbnailFile} multiple={false} maxCount={1}>
                            <Button icon={<UploadOutlined />}>썸네일 파일</Button>
                        </Upload>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item className="searchForm" name="rentBoardFiles" label="썸네일 파일 삭제">
                        <Table
                            className="pointerTable"
                            rowSelection={{
                                type: "checkbox",
                                ...rowSelection,
                            }}
                            rowKey="boardFileId"
                            columns={columns}
                            dataSource={selectedBoardArticle?.files}
                            pagination={false}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row justify="space-between">
                <Col>&#8251; 썸네일 출력 우선 순위: 썸네일파일 &gt; 썸네일URL &gt; 본문 내 첫번째 이미지</Col>
                <Col>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            {editMode === "add" ? "등록" : "수정"}
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}

export default RentRegisterReview;
